export default class helpers {

	static formatPrice(value) {
		if (isNaN(value)) {
			return "";
		}
		var lang = window.globals.lang;
		var separator = lang === "fr" ? " " : ",";
		var formattedNumber = this.numberWithSeparator(value, separator);
		return lang === "fr" ? formattedNumber + " $" : "$" + formattedNumber;
	}

	static numberWithSeparator(value, separator) {
		return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator);
	}

	static getURLParameter(name) {
		return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.search) || [null, ''])[1].replace(/\+/g, '%20')) || null;
	}

	static updateQueryStringParameter(uri, key, value) {
		var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
		var separator = uri.indexOf('?') !== -1 ? "&" : "?";

		if (uri.match(re)) {
			return uri.replace(re, '$1' + key + "=" + value + '$2');
		}
		else {
			return uri + separator + key + "=" + value;
		}
	}

	static scrollToTop(scrollTo, scrollDuration) {
		var cosParameter = (window.pageYOffset - scrollTo) / 2,
			scrollCount = 0,
			oldTimestamp = window.performance.now();

		function step(newTimestamp) {
			var tsDiff = newTimestamp - oldTimestamp;

			scrollCount += Math.PI / (scrollDuration / tsDiff);

			if (scrollCount >= Math.PI) {
				return;
			}

			var moveStep = Math.round(scrollTo + cosParameter + cosParameter * Math.cos(scrollCount));
			window.scrollTo(0, moveStep);
			oldTimestamp = newTimestamp;
			window.requestAnimationFrame(step);
		}

		window.requestAnimationFrame(step);
	}

	static printPdf(url) {
		var iframe = this._printIframe;
		if (!this._printIframe) {
			iframe = this._printIframe = document.createElement('iframe');
			document.body.appendChild(iframe);

			iframe.style.display = 'none';
			iframe.onload = function() {
				setTimeout(function() {
					iframe.focus();
					iframe.contentWindow.print();
				}, 1);
			};
		}

		iframe.src = url;
	}

	static getPowerOfTen(number) {
		var i = 1;
		while((i * 10) < number)
			i *= 10;
		return i;
	}

}
